export function getSocialMetas({
	url,
	title = 'Face Swap Online - AI Face Swapper',
	description = 'Save hours of time in photoshop by using AI to put your face in any picture, with incredible quality and speed.',
	image,
}: {
	image?: string
	url: string
	title?: string
	description?: string
}) {
	return [
		{ title },
		{ name: 'description', content: description },
		{ name: 'image', content: image },
		{ name: 'og:url', content: url },
		{ name: 'og:title', content: title },
		{ name: 'og:description', content: description },
		{ name: 'og:image', content: image },
		{
			name: 'twitter:card',
			content: image ? 'summary_large_image' : 'summary',
		},
		{ name: 'twitter:creator', content: '@luisiacc' },
		{ name: 'twitter:site', content: '@luisiacc' },
		{ name: 'twitter:title', content: title },
		{ name: 'twitter:description', content: description },
		{ name: 'twitter:image', content: image },
		{ name: 'twitter:image:alt', content: title },
		{ name: 'robots', content: 'max-image-preview:large' },
	]
}
